import React, { useEffect } from "react";
import Navbar from "../components/navbar/navbar";
import Hero from "../components/hero/hero";
import Footer from "../components/footer/footer";
import PortfolioPreview from "../components/portfolio/portfolio-preview";
import LogoCarousel from "../components/portfolio/LogoCarousel";

const Home: React.FC = () => {

  return (
    <>
      <Navbar/>
      <Hero />
      <LogoCarousel />
      <PortfolioPreview />
      <Footer />
    </>
  );
};

export default Home;